import { useEffect, useCallback } from 'react';

import { useMarkersContext } from '../context/markers';
import { useHoveredMarkerContext } from 'entities/map';
import { useIsActiveGoogleMap } from 'entities/application';
import { useMapContext } from '../context/map';

const checkIsMarker = ({ object }: any = { object: {} }) => !!(object && object?.coordinates);
const checkIsCluster = ({ object }: any = { object: {} }) => !!(object && object?.cluster);

const useHandlerGoogleStationMarkersHover = () => {
  const { setOverlayProps } = useMarkersContext();
  const { setHoveredMarker } = useHoveredMarkerContext();
  const { addListenerDragStart } = useMapContext();

  const handlerGoogleStationMarkersHover = useCallback(() => {
    const mapElement = document.getElementById('map');
    setOverlayProps({
      onHover: (props: any) => {
        if (checkIsMarker(props)) {
          setHoveredMarker({
            viewportCoords: {
              x: props.x,
              y: props.y
            },
            station: props.object
          });
        } else {
          setHoveredMarker(null);
        }

        if (checkIsMarker(props) || checkIsCluster(props) || !!props.object) {
          if (mapElement) mapElement.style.cursor = 'pointer';
        } else {
          if (mapElement) mapElement.style.cursor = '';
        }
      }
    });

    addListenerDragStart(() => {
      setHoveredMarker(null);
    })
  }, [
    setOverlayProps,
    setHoveredMarker,
    addListenerDragStart
  ]);

  return handlerGoogleStationMarkersHover;
};

export const useHandlerHereStationMarkersHover = () => {
  const { setHoveredMarker } = useHoveredMarkerContext();

  const handlerHereStationMarkersHover = useCallback(({
    data,
    pageX,
    pageY,
    type,
    markerType
  }: any) => {
    if (type === 'pointermove' && markerType === 'marker') {
      setHoveredMarker({
        viewportCoords: {
          x: pageX,
          y: pageY
        },
        station: data
      });
    } else {
      setHoveredMarker(null);
    }
  }, [setHoveredMarker]);

  return handlerHereStationMarkersHover;
};

export const useInitHandlerStationMarkersHover = () => {
  const isActiveGoogleMap = useIsActiveGoogleMap();
  const handlerGoogleStationMarkersHover = useHandlerGoogleStationMarkersHover();

  useEffect(() => {
    if (isActiveGoogleMap) {
      handlerGoogleStationMarkersHover();
    }
  }, [
    isActiveGoogleMap,
    handlerGoogleStationMarkersHover
  ]);
};
